import api from './api';
import {
  Task, TaskStatus, CreateTaskRequest, UpdateTaskRequest, MoveTaskRequest,
  UpdateTaskStatusRequest,
} from '../types';

export const taskService = {
  listByProject: async (projectId: number, tags?: string[]): Promise<Task[]> => {
    const params = tags?.length ? { tag: tags } : undefined;
    const response = await api.get(`/projects/${projectId}/tasks`, { params });
    return response.data;
  },

  getAll: async (statuses?: TaskStatus[]): Promise<Task[]> => {
    const params = statuses?.length ? { status: statuses.join(',') } : undefined;
    const response = await api.get('/tasks', { params });
    return response.data;
  },

  create: async (projectId: number, data: CreateTaskRequest): Promise<Task> => {
    const response = await api.post(`/projects/${projectId}/tasks`, data);
    return response.data;
  },

  update: async (id: number, data: UpdateTaskRequest): Promise<Task> => {
    const response = await api.put(`/tasks/${id}`, data);
    return response.data;
  },

  move: async (id: number, data: MoveTaskRequest): Promise<Task> => {
    const response = await api.patch(`/tasks/${id}/move`, data);
    return response.data;
  },

  updateStatus: async (id: number, data: UpdateTaskStatusRequest): Promise<Task> => {
    const response = await api.patch(`/tasks/${id}/status`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },
};

export default taskService;
